import React from 'react';
import PropTypes from 'prop-types';
import { useGetPublicSpaceQuery } from '../../app/smorgAppSyncGraphQLApi';
import { SPACE_REFRESH_INTERVAL_SECONDS } from '../../services/end_user_published_resources';

const SubscribeContent = ({ spaceID }) => {
  const { data: space } = useGetPublicSpaceQuery(spaceID, {
    skip: !spaceID,
    refetchOnMountOrArgChange: SPACE_REFRESH_INTERVAL_SECONDS,
  });

  const content = space?.subscriptionBenefitsContent;

  if (content) {
    return (
      <div
        style={{ textAlign: 'center' }}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: content }}
      />
    );
  }
  return null;
};

SubscribeContent.propTypes = {
  spaceID: PropTypes.string.isRequired,
};

export default SubscribeContent;
